import { Sidebar } from "components/Sidebar"
import { useSidebarStore } from "hooks/useSidebar"
import { PropsWithChildren } from "react"
import { classNames } from "utils/ClassNames"

export const SidebarLayout = ({ children }: PropsWithChildren) => {
  const collapsed = useSidebarStore((state) => state.collapsed)

  return (
    <>
      <div>
        <Sidebar />

        <main
          className={classNames(
            "py-10 transition-[padding] duration-300 ease-in-out",
            collapsed ? "lg:pl-20" : "lg:pl-72"
          )}
        >
          <div className="px-4 sm:px-6 lg:px-8">{children}</div>
        </main>
      </div>
    </>
  )
}
